import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  position: relative;
  padding-top: 15px;
  padding-bottom: 40px;

  h1 {
    text-align: center;
  }
`;

export const ButtonP5 = styled.button`
  width: 212px;
  height: 39px;
  padding: 8px;
  background: var(--color-primary);
  font-size: 18px;
  color: var(--color-white);
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  ${({ latex10 }) =>
    latex10 === 1 ? " background: var(--color-latex10);" : ""}
  @media (max-height: 650px ) {
    margin-bottom: 0px;
  }
`;

export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px 0;
  flex-shrink: 0;
`;

export const ContainerSinTurno = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 35px;
  margin-top: 81px;
  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
  .subtitle {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
`;
